
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

export class JJNCommand extends Poker2Command {
    protected get cmdId(): string {
        return "jjn";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            this.layoutManager.state = 10;
            var paramObj: any = JSON.parse(params[1]);
            Poker2Model.tournamentData.parse_JJN(paramObj);
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
